import type { PsHttpSSE } from '@/services/sse-ps-http/sse-ps-http';
import { StreamStatus } from '@/services/sse-ps-http/enums';

export const EmbodimentAddApi = Symbol.for('EmbodimentAddApi');

interface RuleItem {
    concept: string;
    replacement: string;
    num: string;
    expand_type: string;
}

export interface ApiEmbodimentAddApiRequest {
    task_id: string;
    rules: RuleItem[];
}

export type ApiEmbodimentAddApiResponse = {
    content: string;
    status: StreamStatus;
}

export interface EmbodimentAddApi {
    embodimentAdd(data: ApiEmbodimentAddApiRequest): PsHttpSSE<ApiEmbodimentAddApiResponse>;
}
